export const getLocalStorage = () => {
    const userId = localStorage.getItem('userId') || '';
    const token = localStorage.getItem('token') || '';
    const firstName = localStorage.getItem('firstName') || '';
    const companyLogo = localStorage.getItem('companyLogo') || '';
    const company = localStorage.getItem('company') || '';
    return { userId, token, firstName, companyLogo, company };
};


